import { render, staticRenderFns } from "./cadlancamentosfluxo.vue?vue&type=template&id=9b2c0148&"
import script from "./cadlancamentosfluxo.vue?vue&type=script&lang=js&"
export * from "./cadlancamentosfluxo.vue?vue&type=script&lang=js&"
import style0 from "./cadlancamentosfluxo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports